import React from 'react';
import { Error } from '~/Components';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import IUser from '~/Models/DTO/User.model';
import { useUserSettings } from '.';
import { UserProfile } from './UserProfile';

export const UserSettings = () => {
  const {
    profileInitialValues,
    changePasswordInitialValues,
    onUserSettingsUpdate,
    actionDisabled,
    setProfileInitialValues,
    setChangePasswordInitialValues,
    activeSection,
    navigate,
    t,
    settingTitle,
    onProfilePictureUpdate,
    currentUser,
    updatingError,
  } = useUserSettings();
  return (
    <PrivateLayout
      actionName={t('app.save')}
      onActionTaken={onUserSettingsUpdate}
      title={settingTitle}
      actionDisabled={actionDisabled}
    >
      <Error error={updatingError} />
      <UserProfile
        currentUser={currentUser as IUser}
        profileInitialValues={profileInitialValues}
        changePasswordInitialValues={changePasswordInitialValues}
        onValidateProfileForm={setProfileInitialValues}
        onValidateChangePassword={setChangePasswordInitialValues}
        activeSection={activeSection}
        onNavigate={navigate}
        t={t}
        onProfilePictureUpdate={onProfilePictureUpdate}
      />
    </PrivateLayout>
  );
};
